import { render, staticRenderFns } from "./PaginaAdminCorreccionesProcurador.vue?vue&type=template&id=82a824a4"
import script from "./PaginaAdminCorreccionesProcurador.vue?vue&type=script&lang=js"
export * from "./PaginaAdminCorreccionesProcurador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports